
<style scoped>
/* Estilos para el botón de añadir más archivos */
.add-file-input-button {
  padding: 8px 15px;
  background-color: #28a745;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  margin-top: 15px;
  margin-bottom: 20px;
}

.add-file-input-button:hover {
  background-color: #218838;
}

</style>
<template>
	<div>
		<app-overlay-loader v-if="preloader" />
		<form ref="form" data-url="/crud" :class="{ 'loading-opacity': preloader }">
			<div v-for="(input, index) in fileInputs" :key="input.id">
				<FileInput
				:label-text="input.labelText"
				:accepted-types="acceptedTypes"
				@file-selected="file => handleFileSelected(file, index)"
				@file-cleared="() => handleFileCleared(index)"
				@remove-input="() => removeFileInput(index)"
				/>
			</div>
			<button type="button" @click="addFileInput" class="add-file-input-button">
				+ Add another file 
			</button>
			<div class="row">
				<div class="col-md-3"></div>
				<div class="col-md-3"></div>
				<div class="col-md-3"></div>
				<div class="col-md-3">
					<button type="button" class="btn btn-success w-100" @click="submitForm" >
					{{ $t("Save Permanently") }}
					</button>
				</div>

				<Modal
					v-if="showModal"
					@close="showModal = false"
					@downloadPO="downloadPO"
					@downloadSO="downloadSO"
					@goToContracts="goToContracts"
				/>
			</div>
		</form>
  	</div>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin.js";
import Modal from "./Modal.vue";
import FileInput from './../components/imports/FileInput.vue'; 


export default {
  	mixins: [FormMixin],
  	name: 'ImportDocuments',
  	
	components: {
    	Modal, FileInput
  	},
  	data() {
		return {
			preloader: false,
			selectedFile: null,
			fileName: '',
			showModal: false,
			acceptedTypes: '*',
			fileInputs: [ 
				{ 
				id: 1,
				labelText: 'Select File 1',
				file: null 
				}
			],
			nextId: 2,
		};
 	},

  	methods: {
		addFileInput() {
      		this.fileInputs.push({
        		id: this.nextId++,
        		labelText: `Select File ${this.nextId - 1}`,
        		file: null,
      		});
    	},

    	handleFileSelected(file, index) {
      		this.fileInputs[index].file = file.file;
    	},

    	handleFileCleared(index) {
      		this.fileInputs[index].file = null;
      		console.log(`File cleaned for input ${index}`);
    	},

    	removeFileInput(index) {
      		this.fileInputs.splice(index, 1);
    	},

		async submitForm() {
      		this.preloader = true;
			try {
				const formData = new FormData();

				const contractMaster = localStorage.getItem("DataContractMaster");
				const contractDetails = localStorage.getItem("DataContractDetail");
				const contractProducts = localStorage.getItem("selectedProducts");
				const contractSupplierDetail = localStorage.getItem("DataSupplierDetail");
				const contractCustomerDetail = localStorage.getItem("DataCustomerDetail");

				formData.append("contractMaster", contractMaster);
				formData.append("contractDetails", contractDetails);
				formData.append("contractProducts", contractProducts);
				formData.append("contractSupplierDetail", contractSupplierDetail);
				formData.append("contractCustomerDetail", contractCustomerDetail);

				console.log(this.fileInputs);
				
				this.fileInputs.forEach((input, index) => {
					if (input.file) {
						formData.append(`uploadedFile_${index}`, input.file); 
					}
				});
				
				const response = await axios.post(
					"/api/contracts/create_contract",
					formData,
				);

				if (response.data.message === 'This contract number already exists. Please enter a unique number.') {
					this.$toastr.e(response.data.message)
				}else{
					this.$toastr.s(response.data.message);
					this.contractId = response.data.contractId;
					setTimeout(() => {
						localStorage.removeItem("DataContractDetail");
						localStorage.removeItem("DataContractMaster");
						localStorage.removeItem("DataProductDetail");
						localStorage.removeItem("DataSupplierDetail");
						localStorage.removeItem("DataCustomerDetail");
						localStorage.removeItem("categorySelected");
						localStorage.removeItem("contractNumber");
						localStorage.removeItem("countrySelected");
						localStorage.removeItem("selectedProducts");
						localStorage.removeItem("process_add_contract");
						localStorage.removeItem("is_from_cost");
					this.showModal = true;
					}, 1000);
				}
			} catch (error) {
				console.log({error});
				
				let msg = "Error saving data";
				if (error.response.data?.error) {
				msg = error.response.data.error;
				}
				console.log(msg, error);
				this.$toastr.e(msg);
			}
			this.preloader = false;
		},
    	downloadPO() {
      		const base_url = localStorage.getItem("base_url");
      		window.open(
        		`${base_url}/contracts/downloadPo/${this.contractId}`,
        		"_blank"
      		);
    	},
		downloadSO() {
			const base_url = localStorage.getItem("base_url");
			window.open(
				`${base_url}/contracts/downloadSo/${this.contractId}`,
				"_blank"
			);
		},
		goToContracts() {
			const base_url = localStorage.getItem("base_url");
			window.location.href = `${base_url}/contracts/list`;
		},
	},
};
</script>
